<template>
  <v-app>
    <v-app-bar color="primary" elevation="0" outline>
      <img
        src="/LetsPlanItInline.png"
        alt="Logo"
        style="width: 150px; height: 33px;margin-top:6px; margin-left: 20px; display: block;"
      />  
      
      <v-spacer />
      <!-- BOUTON MON COMPTE À DROITE -->
        <v-btn class="hover-white-bg" :icon="mdiBriefcasePlus" @click="createNewProject"></v-btn>
        <v-btn class="hover-white-bg" :icon="mdiCheckboxMarkedCirclePlusOutline" @click="gotoAddTask"></v-btn>
        <v-btn class="hover-white-bg" :icon="mdiLogout" @click="logOut"></v-btn>
    </v-app-bar>

    <v-main>
      <router-view />
    </v-main>
    <v-bottom-navigation bg-color="primary" elevation="0" v-model="currentTab" outline>
      <v-btn class="hover-white-bg" value="Home" color="white">
        <v-icon class="ma-1" :icon="mdiHomeOutline" ></v-icon>
        <v-span>Accueil</v-span>
      </v-btn>
      <v-btn class="hover-white-bg" value="MesProjets" color="white">
        <v-icon class="ma-1" :icon="mdiBriefcaseOutline" ></v-icon>
        <v-span>Mes Projets</v-span>
      </v-btn>
      <v-btn class="d-flex flex-column align-center hover-white-bg" value="AgendaTaches" color="white">
        <v-icon class="ma-1" :icon="mdiCalendarOutline" ></v-icon>
        <v-span>Mes Tâches</v-span>
      </v-btn> 
    </v-bottom-navigation>
  </v-app>
</template>

<script setup lang="ts">
import { mdiHomeOutline, mdiBriefcaseOutline, mdiCalendarOutline, mdiLogout, mdiCheckboxMarkedCirclePlusOutline, mdiBriefcasePlus} from '@mdi/js'

import { supabase, createProjetWithUserEdge } from '../supabase/client';
import { useUserSession } from '../composables/useUserSession'
import { useRouter } from 'vue-router';

import { ref, watch } from 'vue'

const router = useRouter();

const currentTab = ref('Home') // valeur par défaut

watch(currentTab, (newVal) => {
  if (newVal === 'Home') {
    router.push('/app')
  }else if (newVal === 'MesProjets') {
    router.push('/mes-projets')  // ou '/app/mes-projets' selon ton routing
  } else if (newVal === 'AgendaTaches') {
    router.push('/calendrier-des-taches')   // ou '/app/mes-taches'
  }
})

const logOut = async () => {
  await supabase.auth.signOut()
  router.push('/')
}


const createNewProject = async () => {

  currentTab.value="";
  router.push('/create-projet');
  /*console.log(" -- Début createNewProject --");
  try{
    console.log("Début useUserSession");
    const { user } = useUserSession();
    console.log("Fin useUserSession");

    if (!user.value) {
      throw new Error('Utilisateur non authentifié');
    }

    const projet = {
      Nom: 'qsdfghjkl',
      DeadLine: new Date(),
      IdProjetParent: null,
      Etat: 3, 
      Type:3
    }
    console.log("Projet = ", projet);

    
    console.log("Début Appel createProjetWithUserEdge");
    const result = await createProjetWithUserEdge(projet, user.value.id)
    console.log("Fin Appel createProjetWithUserEdge");
    console.log('Projet créé via Edge Function:', result)
    
    console.log(" -- Fin createNewProject --")
    console.log(" Redirection vers /app")
    router.push('/mes-projets');

    
  } catch (error) {
    console.error('Erreur création projet via Edge:', error)
  }*/
}

const gotoAddProject= async () => 
{
  console.log('-- Debut fonction de gotoMyAccount --');
  alert("gotoAddProject");
  console.log('-- Fin fonction de gotoMyAccount --');
      
};

const gotoAddTask = async () => 
{
  console.log('-- Debut fonction de gotoMyAccount --');
  alert("gotoAddTask");
  console.log('-- Fin fonction de gotoMyAccount --');
      
};
</script>
